/**
 * 用户动态相关api
 */
import http from './http'

export default class DynamicApi {
    // 获取动态列表
    static getList(params) {
        return http.httpGet('dynamic/list', params);
    }
    // 获取动态项信息
    static getItem(key, id) {
        return http.httpGet('dynamic', {key, id});
    }
    // 点赞
    static like(id) {
        return http.httpPost('dynamic/like', {id});
    }
}



// WEBPACK FOOTER //
// ./app/api/dynamic.api.js